import { useMutation, useQueryClient } from "@tanstack/react-query";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { invalidateSellerStore } from "@/lib/query/core/invalidation";
import type { StoreSocialLink } from "@/lib/api/types";

type UpdateStoreSettingsInput = {
  storeSlug: string;
  clearDepositSettings?: boolean;
  depositType?: "percent" | "flat";
  depositAmount?: number;
  includeShippingInOrderDeposit?: boolean;
  acceptsCod?: boolean;
  autoConfirmCodOrders?: boolean;
  whatsappNumber?: string | null;
  urls?: StoreSocialLink[];
  lowStockThreshold?: number;
  allowOverselling?: boolean;
  unlimitedStock?: boolean;
};

export function useUpdateStoreSettingsMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (input: UpdateStoreSettingsInput) => {
      const { storeSlug: _storeSlug, ...body } = input;
      void _storeSlug;
      return apiJsonClient<unknown>(endpoints.seller.storeSettings, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });
    },
    onSuccess: async (_data, variables) => {
      await invalidateSellerStore(queryClient, variables.storeSlug);
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
}
